import { VOY_TREASURE_HUNT_ADDRESS } from '../config';
const abi = require('./abi/voyage_treasure_hunt.json');

export function getTreasureHuntContract(web3) {
    const instance = new web3.eth.Contract(
        abi,
        VOY_TREASURE_HUNT_ADDRESS
    );
    return instance; 
}